"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
const InvalidSurveyError_1 = __importDefault(require("./errors/InvalidSurveyError"));
class SurveysServiceClient extends client_library_1.Client {
    constructor(fetch, options) {
        super(fetch, options);
    }
    async createSurvey(survey) {
        const url = `${this.url}/api/admin/surveys`;
        const options = { method: 'POST', body: JSON.stringify(survey) };
        const expectedResponses = [201, 422];
        const response = await this.requestMaker.makeRequest(url, options, expectedResponses);
        if (response.status === 422) {
            throw new InvalidSurveyError_1.default();
        }
        return response.json;
    }
    async updateSurvey(_a) {
        var { surveyId } = _a, survey = __rest(_a, ["surveyId"]);
        const url = `${this.url}/api/admin/surveys/${surveyId}`;
        const options = { method: 'POST', body: JSON.stringify(survey) };
        const expectedResponses = [201, 422];
        const response = await this.requestMaker.makeRequest(url, options, expectedResponses);
        if (response.status === 422) {
            throw new InvalidSurveyError_1.default();
        }
        return response.json;
    }
    async fetchAllSurveys(options = {}) {
        let items = [];
        let lastKey;
        do {
            const page = await this.fetchPageOfSurveys(Object.assign(Object.assign({}, options), { lastKey }));
            items.push(...page === null || page === void 0 ? void 0 : page.items);
            lastKey = page.lastKey;
        } while (lastKey);
        return items;
    }
    async fetchPageOfSurveys(options = {}) {
        const baseUrl = `${this.url}/api/surveys`;
        const queryParams = Object.keys(options).reduce((params, key) => {
            if (options[key]) {
                return [...params, `${key}=${encodeURIComponent(options[key])}`];
            }
            return params;
        }, []);
        const url = queryParams.length > 0 ? `${baseUrl}?${queryParams.join('&')}` : baseUrl;
        const requestOptions = { method: 'GET' };
        const expectedResponses = [200];
        const response = await this.requestMaker.makeRequest(url, requestOptions, expectedResponses);
        return response.json;
    }
}
exports.default = SurveysServiceClient;
//# sourceMappingURL=SurveysServiceClient.js.map